import { FC, useEffect, useRef } from 'react';

import { store } from '../../../store/store';
import { LogoVideoCallIcon } from '../../icons/logo-videocall';

import { Trajectory } from '../../../hooks/useDpdgState';
import { IYandexPlayerHandle } from './YandexVideo';
import DpDgBall from './DpDgBall';

export interface IDpDgVideoPanelProps {
  roomName?: string;
  trajectory: Trajectory;
  bgColor: string;
  ballColor: string;
  velocity: number;
  backgroundType: 'none' | 'video' | 'image';
  backgroundValue: string;
  ballSize: number;
  sendDpdgMessage?: (action: string, data: Record<string, unknown>) => void;
  useDataChannelToolTransport?: boolean;
  liveKitBallMoving?: boolean;
}

export const DpDgVideoPanelClient: FC<IDpDgVideoPanelProps> = ({
  roomName,
  bgColor,
  trajectory,
  ballColor,
  velocity,
  backgroundType,
  backgroundValue,
  ballSize,
  sendDpdgMessage,
  useDataChannelToolTransport,
  liveKitBallMoving,
}) => {
  const yandexPlayerRef = useRef<IYandexPlayerHandle>(null);
  const lastSeekRequestedPos = useRef<number | null>(null);

  useEffect(() => {
    if (!yandexPlayerRef.current) return;

    const unsubscribe = store.subscribe(() => {
      const currentState = store.getState().dpdgStateSlice;
      if (!currentState.isPlaying) {
        yandexPlayerRef.current?.pause();
      }
      if (currentState.isPlaying) {
        yandexPlayerRef.current?.play();
      }
      if (lastSeekRequestedPos.current !== currentState.playPosition) {
        lastSeekRequestedPos.current = currentState.playPosition;
        yandexPlayerRef.current?.seek(currentState.playPosition);
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="relative w-full h-full overflow-hidden rounded-[15px]">
      <DpDgBall
        trajectory={trajectory}
        isPsychologist={false}
        roomId={roomName ?? ''}
        bgColor={bgColor}
        ballColor={ballColor}
        velocity={velocity}
        backgroundType={backgroundType}
        backgroundValue={backgroundValue}
        ballSize={ballSize}
        sendDpdgMessage={sendDpdgMessage}
        useDataChannelToolTransport={useDataChannelToolTransport}
        liveKitBallMoving={liveKitBallMoving}
      />
      <div className="absolute top-[15px] right-[15px] w-[89px] h-[25px] lg:w-[172px] lg:h-[50px]">
        <LogoVideoCallIcon className="w-full h-full" />
      </div>
    </div>
  );
};
